import { render, staticRenderFns } from "./IomForm.vue?vue&type=template&id=42dd220e&"
import script from "./IomForm.vue?vue&type=script&lang=js&"
export * from "./IomForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports